import React from 'react';
import InputField from '../../../Forms/Input/InputField';

interface BankDraftPaymentSectionProps {
  voucherCode: string;
  onVoucherChange: (value: string) => void;
}

const BankDraftPaymentSection: React.FC<BankDraftPaymentSectionProps> = ({
  voucherCode,
  onVoucherChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onVoucherChange(e.target.value);
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <InputField
        label="Referencia de Giro Bancario"
        name="bankDraftVoucher"
        iconKey="payment" // puedes usar un ícono específico si tienes
        type="text"
        placeholder="Ingrese la referencia del giro bancario"
        value={voucherCode}
        onChange={handleChange}
      />
    </div>
  );
};

export default BankDraftPaymentSection;
